<template>
    <v-simple-table>
        <template v-slot:default>
            <thead>
                <tr>
                    <th class="text-left pa-0">
                        <v-btn x-small color="success" @click="add">Adicionar Item<v-icon x-small right> add_circle </v-icon></v-btn>
                    </th>
                    <th class="text-left">Título do Item</th>
                    <th class="text-left">Valor de referencia</th>
                    <th class="text-left">Unidade</th>
                    <th class="text-left"></th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(i, index) in items" :key="i">
                    <td>{{ index + 1 }}º Item</td>
                    <td>
                        <v-text-field v-model="i.title" />
                    </td>
                    <td>
                        <v-textarea auto-grow style="font-family: 'courier'" v-model="i.reference" />
                    </td>
                    <td>
                        <v-text-field v-model="i.unit" />
                    </td>
                    <td>
                        <v-btn small color="error" @click="remove(index)"><v-icon small> delete </v-icon></v-btn>
                    </td>
                </tr>
            </tbody>
        </template>
    </v-simple-table>
</template>

<script>
import { mask } from "vue-the-mask";
import rules from "@/helpers/rules";

export default {
    directives: { mask },

    props: {
        items: {
            type: Array,
        },
    },

    watch: {
        items: {
            immediate: true,
            handler(newVal) {
                this.$nextTick(() => {
                    if (newVal == null) {
                        this.numberLines = 1;
                    } else {
                        this.numberLines = this.items ? this.items.length : 1;
                    }
                });
            },
        },
    },

    data() {
        return {
            rules,
            numberLines: 1,
        };
    },

    methods: {
        add() {
            if (this.items && this.numberLines <= 20) {
                this.numberLines++;
                let actual = this.items ? this.items.length : 0;
                for (let index = actual; index < this.numberLines; index++) {
                    this.items.push({ title: "", reference: "", unit: "" });
                }
            }
        },
        remove(index) {
            if (this.items.length >= index) {
                this.items.splice(index, 1);
                this.numberLines--;
            }
        },
    },
};
</script>
